import { useEffect, useRef } from "react"

// Hook to use a broadcast channel to listen for an event and then trigger a callback
export function useBroadcastChannel<T>(channelName: string, callback: (data: T) => void) {
  const channelRef = useRef<BroadcastChannel | null>(null)
  const callBackRef = useRef<typeof callback>(callback)
  callBackRef.current = callback

  useEffect(() => {
    let channel: BroadcastChannel | null = null
    try {
      channel = new BroadcastChannel(channelName)
      channelRef.current = channel
      const handler = (event: MessageEvent<any>) => {
        callBackRef.current(event.data)
      }
      channel.addEventListener("message", handler)
      return () => channel?.removeEventListener("message", handler)
    } catch (e) {
      console.error(e)
    }
  }, [channelName])

  function handlePostMessage(data: T) {
    channelRef.current?.postMessage(data)
    callBackRef.current(data)
  }

  return { postMessage: handlePostMessage }
}
